"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _iconCrossSmall = _interopRequireDefault(require("@amzn/stencil-react-icons/icons/icon-cross-small"));
var _InputActionButton = _interopRequireDefault(require("./InputActionButton"));
var _react2 = require("@emotion/react");
const InputClearButton = _ref => {
  let {
    altText = 'Clear input',
    ...rest
  } = _ref;
  return (0, _react2.jsx)(_InputActionButton.default, (0, _extends2.default)({
    icon: _iconCrossSmall.default,
    altText: altText
  }, rest));
};
InputClearButton.displayName = 'InputClearButton';
var _default = exports.default = InputClearButton;